<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap3">* <i>Book One</i> *<br/>Turn Loose Your Wolf</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 8chap3.vue?c87c3e06